import { useState, useEffect } from 'react'
import { Alert, Table, Button  } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner.js'
import { MY_DEVICES_QUERY, DELETE_USER_DEVICE_MUTATION } from '../../graphql.js'

export const MY_DEVICES = gql(MY_DEVICES_QUERY)
export const DELETE_USER_DEVICE = gql(DELETE_USER_DEVICE_MUTATION)

export default function MyDevices(props) {
  console.log('MyDevices rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [myDevices, setmyDevices] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [refresh, setRefresh] = useState(0)
  const [deleteUserDevice] = useMutation(DELETE_USER_DEVICE)

  useEffect(() => {
    async function fetchItems() {
      console.log('MyDevices.useEffect.fetchItems')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: MY_DEVICES })
        if (data.myDevices) {
          //console.log(data.myDevices)
          setmyDevices(data.myDevices)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    fetchItems()
  }, [refresh])

  async function handleDelete(userAgent) {
    console.log('MyDevices.handleDelete: ', {userAgent})
    await deleteUserDevice({ variables: { userAgent: userAgent } })
    setRefresh(refresh + 1)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (myDevices) {
    const rows = []
    for (let device of myDevices) {
      let backgroundColor = 'white'
      if (device.userAgent === navigator.userAgent) {
        backgroundColor = '#E5F4E7'
      }
      rows.push(
        <tr key={device.mfaCode}>
          <td>{device.dateCreated}</td>
          <td style={{ backgroundColor: backgroundColor }}>{device.userAgent}</td>
          <td>{device.method}</td>
          <td>{device.authorized}</td>
          <td>{device.saveDevice}</td>
          <td><Button size="sm" color="danger" onClick={() => handleDelete(device.userAgent)}>Delete</Button></td>
        </tr>)
    }
    return (
      <div style={{ padding: '20px', backgroundColor: '#F0F2F5', height: '100%' }}>
        <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>My Devices</span>
        <div style={{ height: '100%', overflow: 'auto', paddingTop: '20px' }}>
          <div style={{ textAlign: 'center', padding: '10pxs' }}>
            <Table bordered size="sm" style={{ width: 'auto' }}>
              <thead>
                <tr style={{ backgroundColor: 'white' }}>
                  <td>Current User Agent:</td>
                  <td style={{ textAlign: 'left', fontWeight: 'normal', backgroundColor: '#E5F4E7' }}>{navigator.userAgent}</td>
                  <td colSpan={4}></td>
                </tr>
                <tr>
                  <th>Date Created</th>
                  <th>User Agent</th>
                  <th>MFA Method</th>
                  <th>Authorized</th>
                  <th>Save Device</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    )
  }
  return ''
}
